//http://facebook.github.io/fixed-data-table/
import React from 'react';
import BaseReactComponent from '../../Util/BaseReactComponent';
import styles from './InstallerTable.scss';
import baseComponent from '../../../decorators/baseComponent';
import DataTable from '../../DataTable';

@baseComponent(styles) class InstallerTable extends BaseReactComponent {

  addNewInstaller() {
    this.props.onAddNew();
  }

  onEditInstaller(installer) {
    this.props.onEditInstaller(installer);
  }

  render() {
    return (
      <DataTable rows={this.props.rows.filter(r => r.accountEnabled)} cols={['username', 'email', 'phonenumber', 'edit']} onAddNew={this.addNewInstaller.bind(this)} onEdit={this.onEditInstaller.bind(this)}/>
    );
  }
}

InstallerTable.propTypes = {
  rows: React.PropTypes.array,
  onAddNew: React.PropTypes.func,
  onEditInstaller: React.PropTypes.func
};

export default InstallerTable;



// WEBPACK FOOTER //
// /src/components/HomePage/InstallerTable/InstallerTable.js